import { type AggregatedMetrics } from '@prerender/prerender-shared/FE';
import { type ChartDataset } from 'chart.js';
import { transformToCategories } from '../../../utils/aggregatedMetricsTransformer';

import { Colors } from '~library/prerenderTheme';

function buildResponseTimeDatasets(rawData: AggregatedMetrics.CacheHitMissTimeResult): ChartDataset<'bar'>[] {
  const transformed = transformToCategories(
    rawData,
    () => 'data',
    (v) => v
  );

  // cover edge cases from tests
  if (!transformed.data) {
    transformed.data = rawData.intervals.map(() => null);
  }

  return [
    {
      label: 'Cache hits',
      data: transformed.data.map(
        (item: AggregatedMetrics.CacheHitMissTimeDataItem) => item?.cache_hit_time_avg ?? null
      ),
      backgroundColor: Colors.Mint,
    },
    {
      label: 'Cache misses',
      data: transformed.data.map(
        (item: AggregatedMetrics.CacheHitMissTimeDataItem) => item?.cache_miss_time_avg ?? null
      ),
      backgroundColor: Colors.Gold,
    },
  ];
}

export default buildResponseTimeDatasets;
